module.exports = __webpack_public_path__ + "static/mujeres001.thumb-9fafa294083bce7ab0a6af7c9a89b3cd.jpg";